import { useState, type ReactNode } from 'react';
import { ChevronDown, ChevronRight } from '@retail-ops/panel-shell/fi';

export interface CollapsibleSectionProps {
  title: string;
  /** Meta line shown right-aligned in the header (count, last edited, etc). */
  meta?: string;
  /** Entity-color square indicator on the left of the title. */
  iconColor?: string;
  actions?: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
}

/** Primitive 6: Collapsible record-page section. */
export function CollapsibleSection({
  title,
  meta,
  iconColor,
  actions,
  defaultOpen = true,
  children,
}: CollapsibleSectionProps): JSX.Element {
  const [open, setOpen] = useState<boolean>(defaultOpen);

  return (
    <section className="sect">
      <header className="sect__head">
        <span
          className="sect__icon"
          aria-hidden
          style={iconColor ? { background: iconColor } : undefined}
        />
        <h3 className="sect__title" style={{ fontSize: 13, color: 'var(--pcb-blue-dark)' }}>{title}</h3>
        {meta && <span className="sect__meta">{meta}</span>}
        {actions && <div style={{ marginLeft: meta ? 0 : 'auto' }}>{actions}</div>}
        <button
          type="button"
          className="btn btn-link"
          style={{ marginLeft: 'var(--sp-4)' }}
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          aria-label={open ? 'Collapse section' : 'Expand section'}
        >
          {open ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
        </button>
      </header>
      {open && <div className="sect__body">{children}</div>}
    </section>
  );
}
